import {Button, Card, Form, Spin, Upload} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {LoadingOutlined, PlusOutlined} from "@ant-design/icons";

class Create extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadFile: true,
            count: 1,
            fileList: [],
            file: null,
            loading: false,
            showUploadList: false,
        };
    }

    componentDidMount() {
        const {match, fetch} = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
        }
    }


    handleSubmit = (e) => {
        const {match} = this.props;
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            if (match.params && match.params.id) {
                this.props.onSubmit(values, match.params.id);
            } else {
                this.props.onSubmit(values);
            }
        });
    };

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    customUpload = file => {
        this.setState(state => ({
            fileList: [file],
            file: file,
            showUploadList: true,
        }));
        return false;
    };

    handleChange = async info => {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        this.setState({fileList});
        if (info.file) {
            await this.getBase64(info.file, imageUrl =>
                this.setState({
                    imageUrl,
                    loading: false,
                })
            );
        }
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {data, loading, filters, title, resource} = this.props;
        const {imageUrl} = this.state;
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined/> : <PlusOutlined/>}
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        return (
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
                    <Form onSubmit={this.handleSubmit} layout="vertical">

                        {Object.keys(filters).map((item) => {
                            return getFormFieldByType(filters, item, getFieldDecorator, data, {title: title, resource})
                        })}

                        <Form.Item key={'files'} label="Upload Icon">
                            {getFieldDecorator('files', {
                                rules: [{required: false}],
                                initialValue: (data && data['file']) ? data['file'] : []
                            })(
                                <Upload
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    name="files"
                                    onChange={this.handleChange}
                                    showUploadList={false}
                                    beforeUpload={this.customUpload}
                                    fileList={this.state.fileList}
                                >
                                    {/*upload*/}
                                    {imageUrl || data && data.icon ? <img src={imageUrl || data.icon} alt="avatar"
                                                                          style={{width: '100%'}}/> : uploadButton}
                                </Upload>
                            )}
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        );
    }
}

const CreateForm = Form.create({
    name: 'global_state',
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    },
})(Create);

export default CreateForm;
